/**
 * String utility functions shared across multiple page logic hooks.
 *
 * Originally duplicated in useClientesLogic.ts; extracted here so they can
 * be reused and tested independently.
 */

/**
 * Normalises a value to a lowercase, accent-free, trimmed string.
 * Safe to call with null / undefined values.
 */
export const normalize = (s: any): string =>
  String(s ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

/**
 * Returns true if every character of `term` appears (in order) in the
 * concatenated, normalised representation of the given `fields`.
 * Returns true when `term` is empty.
 */
export const matches = (term: string, ...fields: any[]): boolean => {
  if (!term) return true;
  const haystack = fields.map(normalize).join(" | ");
  return haystack.includes(term);
};
